import {
  auth,
  checkIsApproveCompany,
  redirectCurrentIndexLayout,
  wasPaid,
  isReported,
  isNotReported,
  premium,
} from '@/middleware';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/company',
    component: () => import('@/layouts/CompanyLayout.vue'),
    beforeEnter: [auth, checkIsApproveCompany],
    children: [
      {
        path: '',
        name: 'company.index',
        component: () => import('@/pages/company/IndexPage.vue'),
        meta: {
          title: 'Commute',
        },
      },
      {
        path: '/ecosystem',
        name: 'ecosystem',
        component: () => import('@/pages/ecosystem/Index.vue'),
        meta: {
          title: 'Kooling Reg-X Ecosystem',
        },
      },
      {
        path: '/pscl',
        redirect: { name: 'auth.login' },
        meta: {
          navKey: 'pscl',
          showSelectYear: true,
        },
        children: [
          {
            path: 'step',
            component: () => import('@/pages/CompanyForm/InformationForm.vue'),
            name: 'company.form.page',
            beforeEnter: redirectCurrentIndexLayout(
              'company.form.page',
              'company.form.one',
            ),
            children: [
              {
                path: '1',
                name: 'company.form.one',
                component: () =>
                  import('@/pages/CompanyForm/steps/StepOne.vue'),
                meta: {
                  progress: 5,
                  page: 'one',
                  title: 'Company Profile',
                },
              },
              {
                path: '2',
                component: () =>
                  import('@/pages/CompanyForm/steps/StepTwo.vue'),
                name: 'company.form.two',
                meta: {
                  progress: 10,
                  page: 'two',
                  title: 'Resources for Employees',
                },
              },
              {
                path: '3',
                component: () =>
                  import('@/pages/CompanyForm/steps/StepThree.vue'),
                name: 'company.form.three',
                meta: {
                  progress: 15,
                  page: 'three',
                  title: 'Incentives, Parking Areas and Endowments.',
                },
              },
              {
                path: '4',
                component: () =>
                  import('@/pages/CompanyForm/steps/StepFour.vue'),
                name: 'company.form.four',
                meta: {
                  progress: 20,
                  page: 'four',
                  title: 'Transportation Offer',
                },
              },
              {
                path: '5',
                component: () =>
                  import('@/pages/CompanyForm/steps/StepFive.vue'),
                name: 'company.form.five',
                meta: {
                  progress: 20,
                  page: 'five',
                  title: 'Home Work Travel Analysis',
                },
              },
            ],
          },
          {
            path: 'payment',
            component: () =>
              import('@/pages/CompanyForm/payment/PaymentPage.vue'),
            name: 'company.form.payment',
            beforeEnter: [wasPaid],
            meta: {
              progress: 25,
              meta: {
                title: 'Payment',
              },
            },
          },
          {
            path: 'payment-success',
            component: () =>
              import('@/pages/CompanyForm/payment/PaymentSuccess.vue'),
            name: 'company.form.payment-success',
            meta: {
              progress: 25,
            },
          },
          {
            path: 'upload',
            component: () =>
              import('@/pages/CompanyForm/payment/UploadPage.vue'),
            name: 'company.form.upload',
            beforeEnter: [isReported, premium],
            meta: {
              progress: 25,
              title: 'Employees upload',
              hidePageTitle: true,
            },
          },
          {
            path: 'questions',
            component: () =>
              import('@/pages/CompanyForm/payment/QuestionsPage.vue'),
            name: 'company.form.questions',
            beforeEnter: [isReported, premium],
            meta: {
              progress: 25,
              title: 'Travel Home Work Questionnaire',
            },
          },
          {
            path: 'success',
            component: () => import('@/pages/CompanyForm/ManualSuccess.vue'),
            name: 'company.form.manual-success',
            beforeEnter: [isReported],
            meta: {
              progress: 25,
            },
          },
          {
            path: 'design',
            name: 'design',
            component: () => import('@/pages/design/DesignPage.vue'),
            meta: {
              progress: 35,
              title: 'Design Dashboard',
            },
          },
          {
            path: '/report',
            component: () => import('@/pages/pscl/PsclRoot.vue'),
            children: [
              {
                path: '',
                name: 'company.pscl',
                component: () => import('@/pages/pscl/PSCLPage.vue'),
                meta: {
                  progress: 55,
                  title: 'PSCL',
                },
              },
              {
                path: 'create',
                name: 'design.create',
                component: () => import('@/pages/design/CreateTemplate.vue'),
                meta: {
                  progress: 35,
                  title: 'Create Strategy',
                },
                beforeEnter: [isReported],
              },
              {
                path: ':strategyId',
                name: 'design.edit',
                component: () => import('@/pages/design/EditTemplate.vue'),
                beforeEnter: [isReported],
                meta: {
                  progress: 35,
                  title: 'Edit Strategy',
                },
              },
              {
                path: 'success',
                name: 'company.pscl.success',
                component: () => import('@/pages/pscl/PSCLSuccess.vue'),
                meta: {
                  progress: 55,
                },
              },
            ],
            meta: {
              progress: 55,
            },
          },

          {
            path: '/monitoring',
            name: 'company.monitoring',
            component: () => import('@/pages/monitoring/MonitoringPage.vue'),
            beforeEnter: isNotReported,
            meta: {
              progress: 85,
            },
          },
          {
            path: '/profile',
            name: 'company.profile',
            component: () => import('@/pages/CompanyForm/ProfilePage.vue'),
          },
          {
            path: '/suggestions',
            name: 'company.suggestions',
            component: () =>
              import('@/pages/CompanyForm/CompanySuggestions.vue'),
            meta: {
              title: 'Suggestions',
            },
          },
        ],
      },
    ],
  },
];

export default routes;
